const locale = {
  id: 'TimelineConstant',
  code: 'CN',
  text: {
    "./images/timeline-onboarding-eng@2x.png": "./images/timeline-onboarding-cn@2x.png",
    'Planning': '时间规划',
		'Here you can set up a plan detailing any future plan for your students. ClassTopBase will remind the student, appointed teachers, and their parents to complete the task as planned.': '您可以在这为学生建立未来学业的规划安排，ClassTopBase 会提醒您以及学生、家长按照计划完成教学。',
  }
}

export const onBoardingContents = {
  title: __('Planning', locale),
  text: __('Here you can set up a plan detailing any future plan for your students. ClassTopBase will remind the student, appointed teachers, and their parents to complete the task as planned.', locale),
  image: require(__('./images/timeline-onboarding-eng@2x.png', locale)),
  showArrow: true,
}



// WEBPACK FOOTER //
// ./src/template/Docks/StudentInfo/Timeline/constant.js